// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup-background-overlay {
  display: none;
  height: 100vh;
  width: 100%;
  position: fixed;
  z-index: 29999 !important;
  top: 0px;
  left: 0px;
  background-color: rgba(0, 0, 0, 0.3);
}

/* For Webkit-based browsers (Chrome, Edge, Safari) */
.scroll-container::-webkit-scrollbar {
  width: 6px;
  /* Adjust this value to reduce the width */
}

.scroll-container::-webkit-scrollbar-thumb {
  background: #ccc;
  /* Color of the scrollbar */
  border-radius: 10px;
}

.scroll-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  /* Background of the scrollbar track */
}

.sweet-alert-container {
  border-radius: 15px;
  padding: 20px;
}
.sweet-alert-container .swal2-title {
  color: #000000;
  padding: 15px;
  font-size: 28px;
  font-family: "Open Sans", "Roboto", sans-serif;
}
.sweet-alert-container .swal-html-content {
  color: #000000;
  font-size: 28px;
  font-family: "Open Sans", "Roboto", sans-serif;
  font-weight: 600;
}
.sweet-alert-container .swal2-confirm {
  background-color: #2F80ED !important;
  color: #FFFFFF !important;
  border-radius: 30px !important;
  min-width: 160px;
  min-height: 40px;
  margin: 10px 0px;
}
.sweet-alert-container .swal2-cancel {
  background-color: #FFFFFF !important;
  color: #000000 !important;
  border-radius: 30px !important;
  min-width: 160px;
  min-height: 40px;
  margin: 10px 0px;
  border: 1px solid #B8BFC1 !important;
}
.sweet-alert-container .swal2-actions {
  margin: 15px 0px;
  gap: 15px;
}
.sweet-alert-container .swal2-image {
  height: 70px;
  width: 70px;
  margin: 15px auto;
}
.sweet-alert-container .swal2-close {
  color: #000000;
  font-size: 25px;
  margin: 5px;
}
.sweet-alert-container .swal2-icon {
  scale: 0.6;
  margin: 0px auto 0px;
}
.sweet-alert-container .swal2-error {
  background-color: #f27474 !important;
}
.sweet-alert-container .swal2-success-line-tip,
.sweet-alert-container .swal2-success-line-long,
.sweet-alert-container .swal2-x-mark-line-right,
.sweet-alert-container .swal2-x-mark-line-left {
  background-color: #FFFFFF !important;
  z-index: 3 !important;
}
.sweet-alert-container .swal2-success-ring {
  background-color: #10B981 !important;
}
.sweet-alert-container .swal2-info {
  background-color: #3fc3ee !important;
  color: #ffffff !important;
}
.sweet-alert-container .swal2-question {
  background-color: #87adbd !important;
  color: #ffffff !important;
  border-color: #87adbd !important;
}
.sweet-alert-container .swal2-warning {
  background-color: #F59E0B !important;
  color: #ffffff !important;
  border-color: #F59E0B !important;
}
.sweet-alert-container .swal2-html-container {
  color: #000000;
  font-size: 16px;
  font-family: "Open Sans", "Roboto", sans-serif;
  font-weight: 400;
  padding: 5px 10px 10px 10px;
  margin: auto;
}`, "",{"version":3,"sources":["webpack://./src/client/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;AACF;;AAEA,qDAAA;AACA;EACE,UAAA;EACA,0CAAA;AACF;;AAEA;EACE,gBAAA;EACA,2BAAA;EACA,mBAAA;AACF;;AAEA;EACE,mBAAA;EACA,sCAAA;AACF;;AAEA;EACE,mBAAA;EACA,aAAA;AACF;AACE;EACE,cAAA;EACA,aAAA;EACA,eAAA;EACA,8CAAA;AACJ;AAEE;EACE,cAAA;EACA,eAAA;EACA,8CAAA;EACA,gBAAA;AAAJ;AAGE;EACE,oCAAA;EACA,yBAAA;EACA,8BAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AADJ;AAIE;EACE,oCAAA;EACA,yBAAA;EACA,8BAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oCAAA;AAFJ;AAKE;EACE,gBAAA;EACA,SAAA;AAHJ;AAME;EACE,YAAA;EACA,WAAA;EACA,iBAAA;AAJJ;AAOE;EACE,cAAA;EACA,eAAA;EACA,WAAA;AALJ;AAQE;EACE,UAAA;EACA,oBAAA;AANJ;AASE;EACE,oCAAA;AAPJ;AAUE;;;;EAIE,oCAAA;EACA,qBAAA;AARJ;AAWE;EACE,oCAAA;AATJ;AAYE;EACE,oCAAA;EACA,yBAAA;AAVJ;AAaE;EACE,oCAAA;EACA,yBAAA;EACA,gCAAA;AAXJ;AAcE;EACE,oCAAA;EACA,yBAAA;EACA,gCAAA;AAZJ;AAeE;EACE,cAAA;EACA,eAAA;EACA,8CAAA;EACA,gBAAA;EACA,2BAAA;EACA,YAAA;AAbJ","sourcesContent":[".popup-background-overlay {\n  display: none;\n  height: 100vh;\n  width: 100%;\n  position: fixed;\n  z-index: 29999 !important;\n  top: 0px;\n  left: 0px;\n  background-color: rgba(0, 0, 0, 0.3);\n}\n\n/* For Webkit-based browsers (Chrome, Edge, Safari) */\n.scroll-container::-webkit-scrollbar {\n  width: 6px;\n  /* Adjust this value to reduce the width */\n}\n\n.scroll-container::-webkit-scrollbar-thumb {\n  background: #ccc;\n  /* Color of the scrollbar */\n  border-radius: 10px;\n}\n\n.scroll-container::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  /* Background of the scrollbar track */\n}\n\n.sweet-alert-container {\n  border-radius: 15px;\n  padding: 20px;\n\n  .swal2-title {\n    color: #000000;\n    padding: 15px;\n    font-size: 28px;\n    font-family: \"Open Sans\", \"Roboto\", sans-serif;\n  }\n\n  .swal-html-content {\n    color: #000000;\n    font-size: 28px;\n    font-family: \"Open Sans\", \"Roboto\", sans-serif;\n    font-weight: 600;\n  }\n\n  .swal2-confirm {\n    background-color: #2F80ED !important;\n    color: #FFFFFF !important;\n    border-radius: 30px !important;\n    min-width: 160px;\n    min-height: 40px;\n    margin: 10px 0px;\n  }\n\n  .swal2-cancel {\n    background-color: #FFFFFF !important;\n    color: #000000 !important;\n    border-radius: 30px !important;\n    min-width: 160px;\n    min-height: 40px;\n    margin: 10px 0px;\n    border: 1px solid #B8BFC1 !important;\n  }\n\n  .swal2-actions {\n    margin: 15px 0px;\n    gap: 15px;\n  }\n\n  .swal2-image {\n    height: 70px;\n    width: 70px;\n    margin: 15px auto;\n  }\n\n  .swal2-close {\n    color: #000000;\n    font-size: 25px;\n    margin: 5px;\n  }\n\n  .swal2-icon {\n    scale: 0.6;\n    margin: 0px auto 0px;\n  }\n\n  .swal2-error {\n    background-color: #f27474 !important;\n  }\n\n  .swal2-success-line-tip,\n  .swal2-success-line-long,\n  .swal2-x-mark-line-right,\n  .swal2-x-mark-line-left {\n    background-color: #FFFFFF !important;\n    z-index: 3 !important;\n  }\n\n  .swal2-success-ring {\n    background-color: #10B981 !important;\n  }\n\n  .swal2-info {\n    background-color: #3fc3ee !important;\n    color: #ffffff !important;\n  }\n\n  .swal2-question {\n    background-color: #87adbd !important;\n    color: #ffffff !important;\n    border-color: #87adbd !important;\n  }\n\n  .swal2-warning {\n    background-color: #F59E0B !important;\n    color: #ffffff !important;\n    border-color: #F59E0B !important;\n  }\n\n  .swal2-html-container {\n    color: #000000;\n    font-size: 16px;\n    font-family: \"Open Sans\", \"Roboto\", sans-serif;\n    font-weight: 400;\n    padding: 5px 10px 10px 10px;\n    margin: auto;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
